export const firebaseConfig = {
    apiKey: "AIzaSyCgTkX5P5vENA51HgoWeag0eNJIRzY8YTQ",
    authDomain: "mathlee.firebaseapp.com",
    projectId: "mathlee",
    storageBucket: "mathlee.appspot.com",
    messagingSenderId: "769721156378",
    appId: "1:769721156378:web:8ddf16a905bf964f91e2a3",
    measurementId: "G-0HP95RSVEN"
};